// Base focus-visible treatment for tooltip triggers; customize cursor/shape at callsites.
export const TOOLTIP_TRIGGER_FOCUS_BASE_CLASSES =
  "cursor-help focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background";
